<template>
  <div class="cart-timeout d-flex">
    {{ $t('cart.timeoutLabel') }}
    <div class="timer">
      <strong v-show="isTimerSetup">{{ minutes | twoDigits(minutes) }}:{{ seconds | twoDigits(seconds) }}</strong>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'BsiEntryCountdownTimerSide',
  computed: {
    timerIntervalID() {
      return this.$store.state.cart.timerIntervalID
    },
    entryCountdownTimer() {
      return this.$store.state.cart.entryCountdownTimer
    },
    minutes() {
      return moment.duration(this.entryCountdownTimer).minutes()
    },
    seconds() {
      return moment.duration(this.entryCountdownTimer).seconds()
    },
    isTimerSetup() {
      return this.minutes || this.seconds
    }
  }
}
</script>
<style lang="scss" scoped>
.timer {
  width: 45px;
  margin-left: 5px;
}
</style>
